import React from "react";
import { Link } from "react-router-dom";

interface PostInfo {
  route: string;
  title: string;
}

interface NextBlogParams {
  prev?: PostInfo;
  next?: PostInfo;
}

export const NextBlog: React.FC<NextBlogParams> = ({ prev, next }) => {
  return (
    <div className="my-4 flex items-center justify-between gap-6">
      {prev ? (
        <Link
          to={prev.route}
          rel="prev"
          className="inline-flex min-w-0 items-center gap-2"
        >
          <span aria-hidden="true">←</span>
          <span className="truncate">{prev.title}</span>
        </Link>
      ) : (
        <div />
      )}

      {next ? (
        <Link
          to={next.route}
          rel="next"
          className="inline-flex min-w-0 items-center justify-end gap-2"
        >
          <span className="truncate text-right">{next.title}</span>
          <span aria-hidden="true">→</span>
        </Link>
      ) : (
        <div />
      )}
    </div>
  );
};
